// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2_aBX","head":"Table_head__2r2st","col":"Table_col__1dc_1"};